export const PENDING_EMAIL_VERIFICATION_LOCAL_STORAGE_KEY = '@AuthenticationStore:pendingEmailVerification';

// The "verify your email" step used to live in component state only, so a refresh dropped the user
// back on an empty sign-up form (QA CUX-800). Only the address is kept — never the password.
export function getPendingEmailVerification(): string | undefined {
    try {
        return window.localStorage.getItem(PENDING_EMAIL_VERIFICATION_LOCAL_STORAGE_KEY) || undefined;
    } catch {
        return undefined;
    }
}

export function setPendingEmailVerification(email: string): void {
    try {
        window.localStorage.setItem(PENDING_EMAIL_VERIFICATION_LOCAL_STORAGE_KEY, email);
    } catch {}
}

export function clearPendingEmailVerification(): void {
    try {
        window.localStorage.removeItem(PENDING_EMAIL_VERIFICATION_LOCAL_STORAGE_KEY);
    } catch {}
}
